<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="this.is_inserting"
        >Insert new recipient</md-dialog-title
      >
      <md-dialog-title v-else>Edit recipient</md-dialog-title>

      <md-content class="md-scrollbar">
        <div class="inner-dialog">
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <md-field>
                <label>Name</label>
                <md-input
                  v-model="recipientsData.recipient_name"
                  type="text"
                ></md-input>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field>
                <label>Email</label>
                <md-input
                  v-model="recipientsData.recipient_email"
                  type="text"
                ></md-input>
              </md-field>
            </div>
          </div>
        </div>
      </md-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          >Close</md-button
        >
        <md-button class="md-primary" @click.native="saveRecipient()"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { eventBus } from "../../main";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

export default {
  name: "AddEditRecipients",
  data: () => ({
    is_inserting: false,
    showDialog: false,
    indexOfRecipient: null,
    recipientsData: {
      recipient_name: null,
      recipient_email: null,
    },
  }),
  created() {
    eventBus.$on("showAddEditRecipients", (item, index) => {
      this.showDialog = true;
      if (item) {
        this.is_inserting = false;
        this.recipientsData = item;
        this.indexOfRecipient = index;
      } else {
        this.is_inserting = true;
        this.recipientsData.recipient_name = null;
        this.recipientsData.recipient_email = null;
        this.indexOfRecipient = null;
      }
    });
  },
  methods: {
    saveRecipient: function () {
      let indexToUpdate = this.indexOfRecipient;
      let newRecipient = {
        recipient_name: this.recipientsData.recipient_name,
        recipient_email: this.recipientsData.recipient_email,
      };

      if (this.is_inserting) {
        eventBus.$emit("refreshRecipientsTable", newRecipient, true, null);
      } else {
        eventBus.$emit(
          "refreshRecipientsTable",
          newRecipient,
          false,
          indexToUpdate
        );
      }
      this.showDialog = false;
    },
    showMessageService: function (msg) {
      eventBus.$emit("showMessageService", msg);
    },
  },
};
</script>

<style scoped>
.md-dialog /deep/ .md-dialog-container {
  width: 950px;
  max-height: 650px;
}

.md-content {
  overflow: auto;
  margin-left: 24px;
}

.inner-dialog {
  width: calc(100% - 20px);
  margin: 0px 0px 6px 0px;
}
</style>
